<div class="wrapper relative flex flex-col justify-between h-full">
  <div class="mb-[30px] flex flex-row items-center justify-between">
    <v4-widget-image-caption>
      <div class="image-caption_image">
        <img class="w-[80px] h-[56px] rounded-[10px]" [src]="detail?.cover_url || '/assets/status/placeholder.png'" />
      </div>

      <div class="image-caption_caption ml-3">
        <div class="text-l">{{ detail?.alias }}</div>
        <div class="text-sm">{{ detail?.title }}</div>
      </div>
    </v4-widget-image-caption>

    <div>
      <img src="/assets/v4/icon-delete.svg" class="w-4 h-4 cursor-pointer" (click)="onDeleteListing()" />
    </div>
  </div>

  <div class="flex flex-col flex-1 overflow-y-hidden">
    @if (loading) {
      <nz-skeleton [nzParagraph]="{ rows: 20 }" [nzActive]="true"></nz-skeleton>
    } @else {
      <nz-tabset class="h-full" nzSize="large">
        <nz-tab [nzTitle]="'booking-site_detail_tab_basis' | translate">
          <ng-template nz-tab>
            <bs-listings-detail-basis
              [listingId]="listingId"
              [thirdpartyAccountId]="thirdpartyAccountId"
              [priceInfo]="priceInfo"
              [type]="type"
              [inProgress]="detail?.in_progress"
              (onUpdated)="fetchListingDetail(); onUpdated.emit()"></bs-listings-detail-basis>
          </ng-template>
        </nz-tab>

        @if (type === "self_hosted") {
          <nz-tab [nzTitle]="'booking-site_detail_tab_widget' | translate">
            <ng-template nz-tab>
              <bs-listings-detail-booking-widget
                [listingId]="listingId"
                [thirdpartyAccountId]="thirdpartyAccountId"
                [enabled]="detail?.is_listed"
                [widgetUrl]="widgetUrl"
                (onUpdated)="fetchListingDetail(); onUpdated.emit()"></bs-listings-detail-booking-widget>
            </ng-template>
          </nz-tab>
        }
      </nz-tabset>
    }
  </div>

  <div class="pt-[30px] border-t border-c-gs border-solid bg-white">
    <button nz-button nzSize="large" (click)="onClose()">
      {{ "word.close" | translate }}
    </button>
  </div>
</div>
